import dayjs from 'dayjs'

export function formatDate(date: Date): string {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export const now = () => dayjs()

export function parseDateString(dateString: string): dayjs.Dayjs {
  return dayjs(dateString, 'DD.MM.YYYY', true)
}

export function isValidDate(date: dayjs.ConfigType, format?: string): boolean {
  const dateFormat = format ?? 'DD.MM.YYYY'
  return dayjs(date, dateFormat, true).isValid()
}

export function generateCurrentDate() {
  return now().format('DD.MM.YYYY')
}
